export const formatLanguageCodes = (languageCodes: string[]) => {
  return languageCodes.map((code) => {
    // Keep all parts lowercase to match locale folder structure
    return code.toLowerCase().replace('_', '-');
  });
};
